<template>
    <div class="loader"></div>
</template>

<script>
export default {
    name: "IdentityValidationLoadingOverlay"
};
</script>

<style scoped>
.loader {
    width: 30px;
    height: 30px;
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 2px solid #000000;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
